import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = "TRY") {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: currency,
  }).format(amount);
}

export function formatDate(date, options = {}) {
  const defaultOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...options,
  };
  return new Date(date).toLocaleDateString("tr-TR", defaultOptions);
}

export function formatDateTime(date) {
  return new Date(date).toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getStatusColor(status) {
  const colors = {
    success:    "bg-emerald-100 text-emerald-800 ring-emerald-200/60",
    pending:    "bg-amber-100 text-amber-800 ring-amber-200/60",
    failed:     "bg-rose-100 text-rose-700 ring-rose-200/60",
    processing: "bg-sky-100 text-sky-800 ring-sky-200/60",
    shipped:    "bg-indigo-100 text-indigo-800 ring-indigo-200/60",
    delivered:  "bg-emerald-100 text-emerald-800 ring-emerald-200/60",
    cancelled:  "bg-slate-100 text-slate-600 ring-slate-200/60",
  };
  return colors[status] || colors.pending;
}

export function getStatusLabel(status) {
  const labels = {
    success: "Başarılı",
    pending: "Beklemede",
    failed: "Başarısız",
    processing: "İşleniyor",
    shipped: "Kargoda",
    delivered: "Teslim Edildi",
    cancelled: "İptal",
  };
  return labels[status] || status;
}

export function getChannelInfo(channel) {
  const channels = {
    woocommerce: { label: "WooCommerce", color: "bg-purple-50 text-purple-700", icon: "🛒" },
    shopify: { label: "Shopify", color: "bg-emerald-50 text-emerald-700", icon: "🛍️" },
    shopier: { label: "Shopier", color: "bg-indigo-50 text-indigo-700", icon: "🛍️" },
    ikas: { label: "ikas", color: "bg-muted/50 text-muted-foreground", icon: "🧩" },
    opencart: { label: "OpenCart", color: "bg-sky-50 text-sky-700", icon: "🛒" },
    trendyol: { label: "Trendyol", color: "bg-orange-50 text-orange-700", icon: "🧡" },
    hepsiburada: { label: "Hepsiburada", color: "bg-red-50 text-red-700", icon: "🔴" },
    amazon: { label: "Amazon", color: "bg-amber-50 text-amber-700", icon: "📦" },
    n11: { label: "N11", color: "bg-purple-50 text-purple-700", icon: "🛒" },
    pttavm: { label: "PTTAVM", color: "bg-yellow-50 text-yellow-700", icon: "📮" },
    ciceksepeti: { label: "Ciceksepeti", color: "bg-rose-50 text-rose-700", icon: "🌸" },
    parasut: { label: "Paraşüt", color: "bg-blue-50 text-blue-700", icon: "📊" },
    hepsijet: { label: "HepsiJet", color: "bg-teal-50 text-teal-700", icon: "🚚" },
    yurtici: { label: "Yurtici Kargo", color: "bg-blue-50 text-blue-700", icon: "🚚" },
    dhl: { label: "DHL", color: "bg-yellow-50 text-yellow-700", icon: "🚚" },
    ups: { label: "UPS", color: "bg-amber-50 text-amber-700", icon: "🚚" },
    aras: { label: "Aras Kargo", color: "bg-red-50 text-red-700", icon: "🚚" },
    surat: { label: "Surat Kargo", color: "bg-cyan-50 text-cyan-700", icon: "🚚" },
  };
  return channels[channel] || { label: channel, color: "bg-muted/50 text-muted-foreground", icon: "📌" };
}
